import { Icon } from '@components/icon/Icon';
import cx from 'classnames';
import { getTableRatingDisplay, RATING_OPTIONS } from './ratingOptionsHelper';
import styles from './RatingsLegend.scss';
import typography from '~styles/typography.scss';

export const RatingsLegend = () => (
  <aside className={styles.ratingsLegend} aria-label="Ratings legend">
    <div className={cx(typography.t1, styles.ratingsLegendTitle)}>Ratings</div>
    <p className={typography.t2}>
      Rate your tables based on popularity and Peak will determine pricing for
      each table dynamically.
    </p>
    <p className={typography.t2}>
      Tables with the Economy rating will always be free.
    </p>
    <ul className={styles.ratingsLegendList}>
      {RATING_OPTIONS.map(({ label, value }) => {
        const display = getTableRatingDisplay(value);
        return (
          <li key={label} className={styles.ratingsLegendItem}>
            <span className={typography.t2}>{label}</span>
            <span className={styles.ratingsLegendIcons}>
              {display.type === 'square' && (
                <Icon
                  name="square"
                  className={styles.ratingsLegendIconFilled}
                />
              )}
              {display.type === 'star' && (
                <Icon name="star" className={styles.ratingsLegendIconFilled} />
              )}
              {display.type === 'fire' &&
                Array.from({ length: display.count }, (_, i) => (
                  <Icon
                    key={i}
                    name="fire"
                    className={styles.ratingsLegendIconFilled}
                  />
                ))}
            </span>
          </li>
        );
      })}
    </ul>
  </aside>
);
